import axios from "../../adminCompenents/config/axiosConfig";

export default class WishlistService {
  // 🔹 Ajouter un produit à la wishlist
  addToWishlist = async (data) => {
    try {
      const response = await axios.post("/wishlist", data);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de l'ajout du produit à la wishlist : " + error.message
      );
    }
  };

  // 🔹 Récupérer la wishlist d’un utilisateur spécifique
  getUserWishlist = async (userId) => {
    try {
      const response = await axios.get(`/wishlist/${userId}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération de la wishlist de l'utilisateur : " +
          error.message
      );
    }
  };

  // 🔹 Supprimer un produit de la wishlist
  removeFromWishlist = async (data) => {
    try {
      const response = await axios.delete(`/wishlist`, { data });
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la suppression du produit de la wishlist : " +
          error.message
      );
    }
  };

  // 🔹 Vérifier si un produit est dans la wishlist
  isInWishlist = async (userId, productId) => {
    try {
      const response = await axios.get(`/wishlist/${userId}`);
      const exists = response.data.some(
        (item) => item.productId._id === productId
      );
      return exists;
    } catch (error) {
      throw new Error(
        "Erreur lors de la vérification du produit dans la wishlist : " +
          error.message
      );
    }
  };
}
